const EXPERIMENT_COOKIE_DELIMITER = '#';
const EXPERIMENT_DELIMITER = '|';
const EXPERIMENT_NAME_INDEX_IN_ARRAY = 0;
const BUCKET_NAME_INDEX_IN_ARRAY = 1;
const PAYLOAD_INDEX_IN_ARRAY = 2;

const EXPERIMENT_APP_COOKIE_NAMES = {
  HOME_PAGE: 'dgr_home',
  SEARCH_PAGE: 'dgr_searchresults',
  MERCHANT_PAGE:'dgr_merchant'
};

const EXPERIMENTS = {
  HOMEPAGE_PERSONALIZATION_TEST: {
    NAME: 'BannerPersonalisationMweb',
    BUCKET: {
      PERSONALIZED_HOMEPAGE: 'personalisedmweb',
      NONPERSONALIZED_HOMEPAGE: 'nonpersonalisedmweb',
    },
  },

  SEARCH_PAGE_SPONSORED_COMP_TEST: {
    NAME: 'MwebSponsoredBrand',
    BUCKET: {
      SHOW_COMPONENT_TOP: 'SponsoredComponentatTop',
      SHOW_COMPONENT_BOTTOM: 'SponsoredComponentatBottom',
    },
  },
};

export {
  EXPERIMENT_COOKIE_DELIMITER,
  EXPERIMENT_DELIMITER,
  EXPERIMENT_NAME_INDEX_IN_ARRAY,
  BUCKET_NAME_INDEX_IN_ARRAY,
  PAYLOAD_INDEX_IN_ARRAY,
  EXPERIMENT_APP_COOKIE_NAMES,
  EXPERIMENTS,
};
